import { useEffect, useMemo, useRef } from 'react';
import { FormControl } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setSeparator } from '../common/commonSlice';
import { show as showToast } from '../toast/toastSlice';
import { copy } from '../../services/util';
import { hide } from './weavePracSlice';

function InnerWeavePracModal() {
  const dispatch = useAppDispatch();
  const commands = useAppSelector(state => state.weaveTrainer.commands);
  const separator = useAppSelector(state => state.common.separator);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  
  const textMemo = useMemo(() => {
    return separator?.trim() ? commands.split('\n').join(separator) : commands;
  }, [commands, separator]);
  
  const handleCopyClick = () => {
    copy(textMemo);
    dispatch(hide());
    dispatch(showToast('Copied to clipboard.'));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      handleCopyClick();
    }
  };

  const handleSeparatorChange = (value: string) => {
    dispatch(setSeparator(value));
  }

  return (
    <Modal show={true} onHide={() => dispatch(hide())}>
      <Modal.Header closeButton>
        <Modal.Title>Weave Practices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormControl as="textarea" value={textMemo || 'None'} rows={6} readOnly ref={inputRef} onKeyDown={handleKeyDown} />
      </Modal.Body>
      <Modal.Footer>
        <div className="me-auto">
          <span className="me-2">Separator:</span>
          <FormControl className="separator" as="input" value={separator} onChange={e => handleSeparatorChange(e.target.value)} onKeyDown={handleKeyDown} />
        </div>
        <Button variant="secondary" onClick={() => dispatch(hide())}>
          Close
        </Button>
        <Button variant="primary" onClick={() => handleCopyClick()}>
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function WeavePracModal() {
  const visible = useAppSelector(state => state.weavePrac.visible);  
  return visible ? <InnerWeavePracModal/> : null;
}

export default WeavePracModal;